import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';
import { EhrNpiReportResponse } from '@chiroup/core/types/EhrNpiReport.type';

export const getEhrNpiReport = (): Promise<EhrNpiReportResponse> =>
  ChiroUpAPI.get('api', '/analytics/ehr-npi-report', {});
